import React from "react";
import {handleModalNoticeOverlay, toggleSidebar} from './utils/common';
import {slideNav} from "./utils/common";
import ModalNoticeOverlay from "./ModalNoticeOverlay";

class Sidebar extends React.Component {

    render() {
        return (
            <div>
                <div id="site-sidebar">
                    <div className="sidebar-header">
                        <button onClick={() => toggleSidebar()} className="menu-icon">
                            <span className="menu-icon-bar"></span>
                            <span className="menu-icon-bar"></span>
                            <span className="menu-icon-bar"></span>
                            <span className="menu-icon-label">Menu</span>
                        </button>
                        <a href="/index.html"><img src="/assets-static/46a4e7b4504d43a0ea7dc32d86ef30a3980854a4/images/logo-en.png"
                                                   title="American Immigration" alt="American Immigration"/></a></div>
                    <div className="sidebar-search">
                    </div>
                    <nav className="sidebar-menu" >
                        <a onClick={(e) => slideNav(e, 0)} id="0" className="link-primary ddm-link">U.S. Citizenship</a>
                        <div className="sidebar-ddm" id="citizenship">
                            <ul>
                                <li><a href="/us-citizenship-and-naturalization-application.html">U.S. Citizenship
                                    Application<br/><strong>Form N-400</strong></a></li>
                                <li><a href="/certificate-of-citizenship-N-600.html">Certificate of
                                    Citizenship<br/><strong>Form
                                        N-600</strong></a></li>
                                <li><a href="/replace-certificate-of-citizenship-form-N565.html">Replace Certificate of
                                    Citizenship<br/><strong>Form N-565</strong></a></li>
                                <li><a href="/cart/product/us-citizenship-exam-and-interview-guide-dvd-english.html">U.S.
                                    Citizenship Test and Interview DVD<br/><strong></strong></a></li>
                            </ul>
                        </div>
                        <a onClick={(e) => slideNav(e, 1)} id="1" className="link-primary ddm-link">Green Card</a>
                        <div className="sidebar-ddm">
                            <ul>
                                <li><a href="/replace-lost-stolen-green-card-Form-I-90.html">Green Card
                                    Renewal<br/><strong>Form
                                        I-90</strong></a></li>
                                <li><a href="/replace-lost-stolen-green-card-Form-I-90.html">Green Card
                                    Replacement<br/><strong>Form I-90</strong></a></li>
                                <li><a href="/lost-stolen-green-card-Form-I-90.html">Lost or Stolen Green
                                    Card<br/><strong>Form
                                        I-90</strong></a></li>
                                <li><a href="/I-130-immigrant-petition-green-card.html">Green Card through
                                    Family<br/><strong>Form I-130</strong></a></li>
                                <li><a href="/Adjustment-of-Status-Form-I-485.html">Adjustment of Status <br/><strong>Form
                                    I-485</strong></a></li>
                                <li><a href="/form-i751-remove-conditions-green-card.html">Remove Conditions on Green
                                    Card<br/><strong>Form I-751</strong></a></li>
                                <li><a href="/cart/product/form-i864-affidavit-of-support.html">Affidavit of
                                    Support <br/><strong>Form I-864</strong></a></li>
                                <li><a href="/Form-I-131-Application-Travel-Document.html">Application for Travel
                                    Document<br/><strong>Form I-131</strong></a></li>
                            </ul>
                        </div>
                        <a onClick={(e) => slideNav(e, 2)} id="2" className="link-primary ddm-link">U.S. Visas</a>
                        <div className="sidebar-ddm">
                            <ul>
                                <li><a href="/cart/product/b1-business-visa-application.html">B-1 Business Visa
                                    Application<br/><strong></strong></a></li>
                                <li><a href="/cart/product/b2-tourist-visa-application.html">B-2 Tourist Visa
                                    Application<br/><strong></strong></a></li>
                                <li><a href="/visa-availability-checker.html"> Visa Availability Checker</a></li>
                                <li><a href="/k1-fiancee-visa.html">K-1 Fiancé(e) Visa<br/><strong></strong></a></li>
                                <li><a href="/affidavit-of-support-form-I-134.html">Affidavit of Support<br/><strong>Form
                                    I-134</strong></a></li>
                                <li><a href="/DS-160-nonimmigrant-visa-application.jsp?lang=en">Nonimmigrant Visa
                                    Application<br/><strong>DS-160 Online</strong></a></li>
                            </ul>
                        </div>
                        <a onClick={(e) => slideNav(e, 3)} id="3" className="link-primary ddm-link">Employment</a>
                        <div className="sidebar-ddm">
                            <ul>
                                <li><a href="/form-i765-employment-authorization.html">Employment Authorization Document<br/><strong>Form
                                    I-765</strong></a></li>
                            </ul>
                        </div>
                        <a onClick={(e) => slideNav(e, 4)} id="4" className="link-primary ddm-link">Immigration Forms</a>
                        <div className="sidebar-ddm">
                            <ul>
                                <li><a href="/replace-lost-stolen-green-card-Form-I-90.html">Green Card
                                    Renewal<br/><strong>Form
                                        I-90</strong></a></li>
                                <li><a href="/us-citizenship-and-naturalization-application.html">U.S. Citizenship
                                    Application<br/><strong>Form N-400</strong></a></li>
                                <li><a href="/certificate-of-citizenship-N-600.html">Certificate of
                                    Citizenship<br/><strong>Form
                                        N-600</strong></a></li>
                                <li><a href="/replace-certificate-of-citizenship-form-N565.html">Replace Certificate of
                                    Citizenship<br/><strong>Form N-565</strong></a></li>
                                <li><a href="/deferred-action-application-I-821D.html">Deferred Action for Childhood
                                    Arrivals (DACA)<br/><strong>Form I-821D</strong></a></li>
                                <li><a href="/affidavit-of-support-form-I-134.html">Affidavit of Support<br/><strong>Form
                                    I-134</strong></a></li>
                                <li><a href="/I-130-immigrant-petition-green-card.html">Green Card through
                                    Family<br/><strong>Form I-130</strong></a></li>
                                <li><a href="/Adjustment-of-Status-Form-I-485.html">Adjustment of Status <br/><strong>Form
                                    I-485</strong></a></li>
                                <li><a href="/form-i751-remove-conditions-green-card.html">Remove Conditions on Green
                                    Card<br/><strong>Form I-751</strong></a></li>
                                <li><a href="/cart/product/form-i864-affidavit-of-support.html">Affidavit of
                                    Support <br/><strong>Form I-864</strong></a></li>
                                <li><a href="/Form-I-131-Application-Travel-Document.html">Application for Travel
                                    Document<br/><strong>Form I-131</strong></a></li>
                            </ul>
                        </div>
                        <a onClick={(e) => slideNav(e, 5)} id="5" className="link-primary ddm-link">News &amp; Info</a>
                        <div className="sidebar-ddm">
                            <ul>
                                <li><a href="/blog/">U.S. Immigration Blog<br/><strong></strong></a></li>
                            </ul>
                        </div>
                        <a onClick={(e) => slideNav(e, 6)} id="6" className="link-primary ddm-link">USCIS</a>
                        <div className="sidebar-ddm">
                            <ul>
                                <li><a href="/uscis-fee-increase-alert/">USCIS Filing Fee Increase<br/><strong></strong></a>
                                </li>
                                <li><a href="/uscis/us-local-offices.html">USCIS Local Offices<br/><strong></strong></a>
                                </li>
                                <li><a href="/immigration-definition-a.html">Immigration Glossary<br/><strong></strong></a>
                                </li>
                                <li><a href="/case-status/case/">Check Case Status<br/><strong></strong></a></li>
                                <li><a href="/uscis-forms.html">USCIS Forms<br/><strong></strong></a></li>
                                <li><a href="/green-card-expiration-reminder-service">Green Card Expiration Service<br/><strong></strong></a></li>
                            </ul>
                        </div>
                        <a href="/cart/category/immigration-forms.html" className="link-secondary">Find a Form</a>
                        <a href="/contact.jsp?lang=en" className="link-secondary">Contact Us</a><a
                            href="/espanol/index.html" className="link-secondary switch-lang">Español</a></nav>
                </div>
                <div id="faded-bg" onClick={() => toggleSidebar()}>&nbsp;</div>
            </div>
        );
    }
}

export default Sidebar;
